<template>
  <div class="content-container" style="height: auto">
    <div class="content-box">
      <section
        ref="agGridWrapper"
        v-loading="tableLoading"
        class="section-box outline"
      >
        <search-comp @onSearch="onSearch" @onReset="onResetSearch">
          <div class="das-form-container">
            <div class="das-form-group">
              <div class="das-form-row">
                <div class="das-form-col col-4">
                  <div
                    class="das-form-input"
                    title="Tìm kiếm theo mã, tên công ty/đại lý du lịch"
                  >
                    <div class="label">
                      {{ 'Nhập từ khóa' }}
                    </div>
                    <div class="">
                      <input v-model="searchParams.keyword" type="text" />
                    </div>
                  </div>
                </div>
                <div class="das-form-col col-4">
                  <div class="das-form-input">
                    <div class="label">
                      {{ 'Tên nguồn' }}
                    </div>
                    <div class="">
                      <select-with-search-table
                        style="width: 100%"
                        :rows="sourceOptions"
                        :columns="columnsSource"
                        index-field="id"
                        :dropdown-width="400"
                        :is-remove-btn="true"
                        :selected-index-field-value="searchParams.agentId"
                        :value="searchParams.agentId"
                        @selectionChanged="onSelectRowSource"
                      >
                        <template
                          v-slot:value="{ selectedValue: selectedData }"
                        >
                          {{ selectedData?.name }}
                        </template>
                      </select-with-search-table>
                    </div>
                  </div>
                </div>

                <div class="das-form-col col-4">
                  <div class="das-form-input">
                    <div class="label">
                      {{ 'Khoảng ngày' }}
                    </div>
                    <div class="">
                      <CalendarRange v-model="searchParams.date" mode="date" />
                    </div>
                  </div>
                </div>
                <!-- <div class="das-form-col col-4">
              <div class="das-form-input">
                <div class="label">
                  {{ 'Khách sạn' }}
                </div>
                <div class="">
                  <el-select
                    v-model="searchParams.hotelIdList"
                    multiple
                    collapse-tags
                  >
                    <el-option
                      v-for="(hotel, index) in hotelList"
                      :key="index"
                      :value="hotel.id"
                      :label="hotel.name"
                    ></el-option>
                  </el-select>
                </div>
              </div>
            </div> -->
              </div>
            </div>
          </div>
        </search-comp>

        <div class="das-form-container">
          <div class="das-form-title-container" style="display: flex">
            <div class="das-form-title">
              <span class="main-title">
                {{ `Báo cáo tổng hợp công nợ` }}
              </span>
            </div>

            <DownloadBtn
              @openNoteDialog="dialogNoteVisible = true"
              @exportExcel="downloadExcel"
            />
          </div>
          <hr />

          <div class="grid-scroll mt-10">
            <GridVx
              ref="agGrid"
              :style="rows.length <= 0 ? 'height: 400px' : ''"
              :columns="columns"
              :rows="rows"
              row-selection="single"
              class="agGrid"
              :row-class-rules="rowClassRules"
              :get-row-class="getRowClass"
              :auto-size-cell="true"
              :pinned-bottom-row-data="pinnedBottomRowData"
              @selectionChanged="onSelectionChanged"
            />
          </div>

          <div class="button-containers mb-0">
            <button
              :disabled="selectedRows.length !== 1"
              class="btn primary small"
              @click="openDetailNewTab"
            >
              {{ 'Xem chi tiết' }}
            </button>
          </div>
        </div>
      </section>

      <section v-loading="pieChartLoading" class="section-box outline">
        <search-comp @onSearch="onSearchPie" @onReset="onResetSearchPie">
          <div class="das-form-container">
            <div class="das-form-group">
              <div class="das-form-row">
                <div class="das-form-col col-4">
                  <div class="das-form-input">
                    <div class="label">
                      {{ 'Khoảng ngày' }}
                    </div>
                    <div class="">
                      <CalendarRange
                        v-model="pieChartSearchParams.date"
                        mode="date"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </search-comp>

        <div class="das-form-container mt-10">
          <div class="das-form-group">
            <div class="das-form-row">
              <div class="das-form-col col-12">
                <div class="chartwithbutton">
                  <vchart
                    style="height: 500px"
                    class="chart"
                    :option="optionPieChart"
                    autoresize
                    @click="handleClickPieChart"
                  />
                  <div class="button-containers-title">
                    <button class="btn small primary outline download-button">
                      <i class="el-icon-download"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section v-loading="lineChartLoading" class="section-box outline">
        <search-comp @onSearch="onSearchLine" @onReset="onResetSearchLine">
          <div class="das-form-container">
            <div class="das-form-group">
              <div class="das-form-row">
                <div class="das-form-col col-4">
                  <div class="das-form-input">
                    <div class="label">
                      {{ 'Tên công ty đại lý' }}
                    </div>
                    <div class="">
                      <select-with-search-table
                        style="width: 100%"
                        :rows="sourceOptions"
                        :columns="columnsSource"
                        index-field="id"
                        :dropdown-width="400"
                        :is-remove-btn="true"
                        :selected-index-field-value="
                          lineChartSearchParams.agentId
                        "
                        :value="lineChartSearchParams.agentId"
                        @selectionChanged="onSelectRowSourceLine"
                      >
                        <template
                          v-slot:value="{ selectedValue: selectedData }"
                        >
                          {{ selectedData?.name }}
                        </template>
                      </select-with-search-table>
                    </div>
                  </div>
                </div>
                <div class="das-form-col col-4">
                  <div class="das-form-input">
                    <div class="label">
                      {{ 'Khoảng ngày' }}
                    </div>
                    <div class="">
                      <CalendarRange
                        v-model="lineChartSearchParams.date"
                        mode="date"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </search-comp>

        <div class="das-form-container">
          <div class="das-form-group">
            <div class="das-form-row">
              <div class="das-form-col col-12">
                <div class="chartwithbutton">
                  <vchart
                    style="height: 400px"
                    class="chart"
                    :option="optionLineChart"
                    autoresize
                  />
                  <div class="button-containers-title">
                    <button class="btn small primary outline download-button">
                      <i class="el-icon-download"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>

    <NoteDialog v-model="dialogNoteVisible">
      <div class="das-form-container">
        <div class="das-form-group">
          <ul class="annotate-container">
            <li>Công ty/đại lý: Hiển thị công ty có công nợ</li>
            <li>Dư nợ đầu kỳ: Hiển thị số tiền dư nợ đầu kỳ của Công ty</li>
            <li>Phát sinh tăng: Số tiền phát sinh của hóa đơn</li>
            <li>Phát sinh giảm: Số tiền công ty đại lý đã thanh toán</li>
            <li>Dư nợ cuối kỳ: Hiển thị số tiền dư nợ cuối kỳ của Công ty</li>
            <li>Hạn mức còn lại: Số tiền công nợ tối đa còn lại có thể nợ</li>
          </ul>
        </div>
      </div>
    </NoteDialog>
  </div>
</template>

<script>
/* eslint-disable */
import DownloadBtn from './components/DownloadBtn.vue'
import NoteDialog from './components/NoteDialog.vue'
import CalendarRange from '@/components/CalendarSelect/CalendarRange.vue'
import CellRendererLink from './components/CellRenderLink.vue'

import { getAllHotel } from '@/api/hotel'
// import { getSourceApi } from '@/api/Statistics/source'
import { getAgentSimpleListApi } from '@/api/configuration/profile/agent'
import {
  getDebtReport,
  getDebtReportExcel,
  getGrowthChart
} from '@/api/report_service/datntReport'
import { color } from '@/utils/color'

import { formatVND } from '@/utils/commonUtils'
import { downFile } from '@/utils/file-handler'

const getOptionPieChartDefault = () => ({
  title: {
    text: 'Biểu đồ tròn theo công nợ cuối kỳ của từng nguồn công nợ'
    // left: '5%'
  },
  color: color,
  tooltip: {
    trigger: 'item',
    confine: true,
    extraCssText: 'overflow: scroll;text-wrap: wrap;',
    valueFormatter: value => value + '%'
  },
  legend: {
    orient: 'vertical',
    textStyle: {
      width: 300,
      overflow: 'break'
    },
    top: 50,
    left: '5%',
    type: 'scroll'
    // bottom: 20
  },
  series: [
    {
      name: 'Nguồn',
      type: 'pie',
      // right: '10%',
      left: '40%',
      width: '60%',
      avoidLabelOverlap: true,
      radius: '85%',
      data: [],
      emphasis: {
        itemStyle: {
          shadowBlur: 10,
          shadowOffsetX: 0,
          shadowColor: 'rgba(0, 0, 0, 0.5)'
        }
      }
    }
  ]
})
const getOptionLineChartDefault = () => ({
  title: {
    text: 'Biểu đồ tăng trưởng của các nguồn'
  },
  color: color,
  tooltip: {
    trigger: 'axis',
    axisPointer: {
      type: 'cross'
    },
    confine: true,
    extraCssText: 'height: 300px;overflow: scroll;text-wrap: wrap;',
    valueFormatter: value =>
      value !== null ? value.toLocaleString('en-US') : null,
    enterable: true
  },
  legend: {
    bottom: 0,
    type: 'scroll'
  },
  grid: {
    left: '6%',
    right: '4%',
    top: 70,
    bottom: 100
  },
  xAxis: [
    {
      type: 'category',
      axisTick: {
        alignWithLabel: true
      },
      axisLine: {
        onZero: false
        // lineStyle: {
        //   color: '#5470C6'
        // }
      },
      // axisPointer: {
      //   label: {
      //     formatter: function (params) {
      //       return (
      //         'Precipitation  ' +
      //         params.value +
      //         (params.seriesData.length ? '：' + params.seriesData[0].data : '')
      //       )
      //     }
      //   }
      // },
      // prettier-ignore
      data: []
    }
  ],
  yAxis: [
    {
      type: 'value'
    }
  ],
  series: []
})

export default {
  components: { CalendarRange, DownloadBtn, NoteDialog, CellRendererLink },
  data() {
    return {
      searchParams: {
        date: {
          start: this.$moment().startOf('month').format('YYYY-MM-DD'),
          end: this.$moment().format('YYYY-MM-DD')
        },
        agentId: null, // source
        keyword: null
        // hotelIdList: null
      },
      defaultSearchParams: {
        date: {
          start: this.$moment().startOf('month').format('YYYY-MM-DD'),
          end: this.$moment().format('YYYY-MM-DD')
        },
        agentId: null, // source
        keyword: null
        // hotelIdList: null
      },

      // data for search
      sourceOptions: [],
      columnsSource: [
        {
          headerName: 'Mã đại lý',
          field: 'code',
          minWidth: 120,
          maxWidth: 150
        },
        {
          headerName: 'Mô tả',
          field: 'name',
          // tooltipFiled: 'desc',
          flex: 1
        }
      ],

      hotelList: [],

      // grid
      rows: [],
      selectedRows: [],
      pinnedBottomRowData: [],
      rowClassRules: {
        warning: params => params.data?.warning == true
      },

      // section
      tableLoading: false,
      pieChartLoading: false,
      lineChartLoading: false,

      // dialog
      dialogNoteVisible: false,

      // pie chart
      optionPieChart: getOptionPieChartDefault(),
      pieChartSearchParams: {
        date: {
          start: this.$moment().startOf('month').format('YYYY-MM-DD'),
          end: this.$moment().format('YYYY-MM-DD')
        },
        dateFrom: null,
        dateTo: null
      },
      defaultPieChartSearchParams: {
        date: {
          start: this.$moment().startOf('month').format('YYYY-MM-DD'),
          end: this.$moment().format('YYYY-MM-DD')
        },
        dateFrom: null,
        dateTo: null
      },

      // line chart
      optionLineChart: getOptionLineChartDefault(),
      lineChartSearchParams: {
        date: {
          start: this.$moment().subtract(3, 'days').format('YYYY-MM-DD'),
          end: this.$moment().format('YYYY-MM-DD')
        },
        agentId: null // source
      },
      defaultLineChartSearchParams: {
        date: {
          start: this.$moment().subtract(3, 'days').format('YYYY-MM-DD'),
          end: this.$moment().format('YYYY-MM-DD')
        },
        agentId: null // source
      }
    }
  },

  computed: {
    columns() {
      return [
        {
          headerdesc: '',
          minWidth: 50,
          maxWidth: 50,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          checkboxSelection: true,
          resizable: false,
          sortable: false
        },
        {
          headerName: 'Mã công ty/đại lý',
          field: 'profile_code',
          tooltipField: 'profile_code',
          minWidth: 300
        },
        {
          headerName: 'Công ty/đại lý',
          tooltipField: 'agent_nm',
          field: 'agent_nm',
          minWidth: 300
        },
        {
          headerName: 'Dư nợ đầu kỳ',
          field: 'debt_begin',
          cellClass: 'ag-cell-right',
          minWidth: 100,
          valueGetter: params => formatVND(params.data.debt_begin, null),
          tooltipValueGetter: params => formatVND(params.data.debt_begin, null)
        },
        {
          headerName: 'Phát sinh tăng',
          field: 'increase',
          minWidth: 100,
          cellClass: 'ag-cell-right',
          tooltipValueGetter: params => formatVND(params.data.increase, null),
          valueGetter: params => formatVND(params.data.increase, null)
        },
        {
          headerName: 'Phát sinh giảm',
          field: 'decrease',
          cellClass: 'ag-cell-right',
          minWidth: 100,
          tooltipValueGetter: params => formatVND(params.data.decrease, null),
          valueGetter: params => formatVND(params.data.decrease, null)
        },
        {
          headerName: 'Dư nợ cuối kỳ',
          field: 'debt_end',
          cellClass: 'ag-cell-right',
          minWidth: 100,
          tooltipValueGetter: params => formatVND(params.data.debt_end, null),
          valueGetter: params => formatVND(params.data.debt_end, null)
        },
        {
          headerName: 'Hạn mức còn lại',
          field: 'remaining_limit',
          cellClass: 'ag-cell-right',
          tooltipValueGetter: params =>
            formatVND(params.data.remaining_limit, null),
          valueGetter: params => formatVND(params.data.remaining_limit, null),
          minWidth: 100
        },
        {
          headerName: 'Cảnh báo',
          field: 'warning',
          minWidth: 100,

          valueGetter: params =>
            params.data?.warning == true ? 'Cảnh báo' : '',
          tooltipValueGetter: params =>
            params.data?.warning == true ? 'Cảnh báo' : ''
        }
        // {
        //   headerName: 'Xem chi tiết',
        //   field: '',
        //   cellRenderer: 'CellRendererLink',
        //   cellRendererParams: params => ({
        //     show: params.data?.agent_id || null,
        //     text: 'Xem',
        //     link: '/report/cfo_report/detail_debt_report',
        //     query: {
        //       agentId: params.data?.agent_id,
        //       start: this.searchParams.date.start,
        //       end: this.searchParams.date.end
        //       // date: params.data?. // need encodeURIComponent
        //     }
        //   })
        // }
      ]
    }
  },

  async mounted() {
    await this.getListHotel()
    await this.getListSource()
    await this.fnGetDebtReport()

    await this.onSearchPie()
    await this.onSearchLine()
  },

  methods: {
    onSearch() {
      this.fnGetDebtReport()
    },
    onResetSearch() {
      this.searchParams = { ...this.defaultSearchParams }
      this.fnGetDebtReport()
    },

    getRowClass(params) {
      if (params.data?.warning == true) {
        return 'debt-report-row-' + 'warning'
      }
      return ''
    },
    onSelectionChanged(selectedRows) {
      this.selectedRows = selectedRows
    },

    onSelectRowSource(val) {
      this.searchParams.agentId = val?.id || null
    },
    onSelectRowSourceLine(val) {
      this.lineChartSearchParams.agentId = val?.id || null
    },
    openDetailNewTab() {
      let resolvedRoute = this.$router.resolve({
        path: '/report/cfo_report/detail_debt_report',
        query: {
          agentId: this.selectedRows[0].agent_id
        }
      })
      window.open(resolvedRoute.href, '_blank')
    },

    // handle api call
    async fnGetDebtReport() {
      this.tableLoading = true
      try {
        const query = {
          keyword: this.searchParams.keyword,
          agentId: this.searchParams.agentId,
          dateFrom: this.searchParams.date.start,
          dateTo: this.searchParams.date.end
          // hotelIdList: this.searchParams.hotelIdList
        }
        const res = await getDebtReport(query)
        this.rows = res.data

        this.pinnedBottomRowData = [
          {
            agent_id: null,
            agent_nm: 'Tổng',
            debt_begin: res.map.total_debt_begin,
            increase: res.map.total_increase,
            decrease: res.map.total_decrease,
            debt_end: res.map.total_debt_end
          }
        ]
      } catch (error) {
        this.$message({
          type: 'error',
          message: this.$t(
            'errorMsg.' + error?.response?.data?.message
              ? error?.response?.data?.message
              : error
          )
        })
      } finally {
        this.tableLoading = false
      }
    },
    async downloadExcel() {
      this.tableLoading = true
      try {
        const query = {
          keyword: this.searchParams.keyword,
          sourceId: this.searchParams.sourceId,
          dateFrom: this.searchParams.monthRange
            ? this.$moment
                .utc(this.searchParams.monthRange)
                ?.add(1, 'days')
                ?.format('YYYY-MM-DD')
            : null,
          dateTo: this.searchParams.monthRange
            ? this.$moment
                .utc(this.searchParams.monthRange)
                ?.add(1, 'days')
                ?.endOf('month')
                ?.format('YYYY-MM-DD')
            : null
          // pageSize: this.pageParams.pageSize,
          // pageNum: this.pageParams.pageNum
          // hotelIdList: this.searchParams.hotelIdList
        }
        const res = await getDebtReportExcel(query)
        const date = this.$moment().format('DD-MM-YYYY')
        downFile(res, 'bao_cao_tong_hop_cong_no_' + date + '.xlsx')
      } catch (error) {
        console.log(error)
        this.$message({
          type: 'error',
          message: this.$t(
            'errorMsg.' + error?.response?.data?.message
              ? error?.response?.data?.message
              : error
          )
        })
      } finally {
        this.tableLoading = false
      }
    },
    async getListHotel() {
      const data = await getAllHotel()
      this.hotelList = data.data
    },
    async getListSource() {
      const data = await getAgentSimpleListApi()
      this.sourceOptions = data.data
    },

    // pie chart handle
    async handleClickPieChart(e) {
      this.searchParams.date = {
        start: this.pieChartSearchParams.date.start,
        end: this.pieChartSearchParams.date.end
      }
      this.searchParams.agentId = this.sourceOptions.filter(
        item => item.name === e.name
      )[0].id
      await this.fnGetDebtReport()

      this.$refs.agGridWrapper.scrollIntoView({ behavior: 'smooth' })
    },
    async onSearchPie() {
      const query = {
        dateFrom: this.pieChartSearchParams.date.start,
        dateTo: this.pieChartSearchParams.date.end
      }
      if (query.dateFrom === null || query.dateTo === null) {
        this.$message({
          type: 'error',
          message: 'Vui lòng nhập khoảng thời gian.'
        })
        return
      }
      this.pieChartLoading = true
      this.optionPieChart = getOptionPieChartDefault()

      try {
        const res = await getDebtReport(query)
        const total = res.map.total_debt_end

        this.optionPieChart.series[0].data = res.data.map(item => ({
          value: ((item.debt_end / total) * 100).toFixed(2),
          name: item.agent_nm
        }))
      } catch (error) {
        this.$message({
          type: 'error',
          message: this.$t(
            'errorMsg.' + error?.response?.data?.message
              ? error?.response?.data?.message
              : error
          )
        })
      } finally {
        this.pieChartLoading = false
      }
    },
    onResetSearchPie() {
      this.pieChartSearchParams = Object.assign(
        {},
        this.defaultPieChartSearchParams
      )
      this.onSearchPie()
    },

    // line chart handle
    async onSearchLine() {
      const query = {
        dateFrom: this.lineChartSearchParams.date.start,
        dateTo: this.lineChartSearchParams.date.end,
        agentId: this.lineChartSearchParams.agentId
      }
      if (query.dateFrom === null || query.dateTo === null) {
        this.$message({
          type: 'error',
          message: 'Vui lòng nhập khoảng thời gian.'
        })
        return
      }
      // console.log(
      //   this.$moment(query.dateTo, 'YYYY-MM-DD').diff(
      //     this.$moment(query.dateFrom, 'YYYY-MM-DD'),
      //     'days'
      //   )
      // )

      if (
        this.$moment(query.dateTo, 'YYYY-MM-DD').diff(
          this.$moment(query.dateFrom, 'YYYY-MM-DD'),
          'days'
        ) < 3
      ) {
        this.$message({
          type: 'error',
          message: 'Khoảng thời gian tối thiểu là 3 ngày.'
        })
        return
      }
      this.lineChartLoading = true
      this.optionLineChart = getOptionLineChartDefault()

      try {
        const res = await getGrowthChart(query)
        this.optionLineChart.xAxis[0].data = res.map.day
        // console.log(res.map.debt_account_list.entries())
        for (const [index, agent] of res.map.debt_account_list.entries()) {
          this.optionLineChart.series[index] = {
            name: agent.agent_nm,
            id: agent.agent_id,
            type: 'line',
            xAxisIndex: 0,
            smooth: true,
            emphasis: {
              focus: 'series'
            },
            data: agent.debtIncreaseByDayList.map(item => {
              return Math.abs(item)
            })
          }
        }
      } catch (error) {
        this.$message({
          type: 'error',
          message: this.$t(
            'errorMsg.' + error?.response?.data?.message
              ? error?.response?.data?.message
              : error
          )
        })
      } finally {
        this.lineChartLoading = false
      }
    },
    onResetSearchLine() {
      this.lineChartSearchParams = Object.assign(
        {},
        this.defaultLineChartSearchParams
      )
      this.onSearchLine()
    }
  }
}
</script>
